<template>
  <v-card flat max-width="800">
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <h3 class="text-h6">¿Como quisieras recibir tu pedido?</h3>
        </v-col>

        <v-col cols="6">
          <card-button
              :selected="isTakeAway"
              :title="$t('delivery.mode.takeAway')"
              icon="store"
              @click="takeAway"
          ></card-button>
        </v-col>

        <v-col cols="6">
          <card-button
              :selected="isDelivery"
              :title="$t('delivery.mode.delivery')"
              icon="delivery_dining"
              @click="delivery"
          ></card-button>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-text>
      <customer-order-mode-take-away v-if="isTakeAway"></customer-order-mode-take-away>
      <customer-order-mode-delivery v-if="isDelivery"></customer-order-mode-delivery>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <submit-button
          text="common.next"
          @click="$emit('next')"
          :disabled="!$store.getters.orderSystem.isDeliveryReady"
      ></submit-button>
    </v-card-actions>

  </v-card>
</template>

<script>

import {SubmitButton} from "@dracul/common-frontend"
import CardButton from "@/modules/delivery/components/CardButton/CardButton.vue";
import {DELIVERY, TAKE_AWAY} from "@/modules/delivery/constants/OrderDelivery";
import CustomerOrderModeTakeAway
  from "@/modules/delivery/components-core/customer/CustomerOrderModeTakeAway/CustomerOrderModeTakeAway.vue";
import CustomerOrderModeDelivery
  from "@/modules/delivery/components-core/customer/CustomerOrderModeDelivery/CustomerOrderModeDelivery.vue";

export default {
  name: "CustomerOrderMode",
  components: {CustomerOrderModeDelivery, CustomerOrderModeTakeAway,  CardButton, SubmitButton},
  computed: {
    isTakeAway() {
      return this.$store.getters.orderSystem.order.isTakeAway
    },
    isDelivery() {
      return this.$store.getters.orderSystem.order.isDelivery
    }
  },
  methods: {
    takeAway() {
      this.$store.commit('orderDeliveryMode',TAKE_AWAY)
    },
    delivery() {
      this.$store.commit('orderDeliveryMode',DELIVERY)
      //this.$store.commit('clearOrderLocation')
    },
  }
}
</script>

<style scoped>

</style>
